import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// @mui material components
import { Card, Grid, Tab, Tabs } from '@mui/material';

// Material Dashboard 2 React components
import MDBox from 'components/MDBox';
import DuplicateUsers from './components/DuplicateUsers';
import NonUSUsers from './components/NonUSUsers';
import USUsers from './components/USUsers';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const UserManagement = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [value, setValue] = useState('US');

  const handleTabSelect = (tabKey) => {
    switch (tabKey) {
      case 'US':
        navigate(
          {
            hash: 'US',
          },
          { replace: true }
        );
        setValue(tabKey);
        break;

      case 'NonUS':
        navigate(
          {
            hash: 'NonUS',
          },
          { replace: true }
        );
        setValue(tabKey);
        break;
      
      case 'Duplicate': 
        navigate({ hash: 'Duplicate' }, { replace: true });
        setValue(tabKey);
        break;

      default:
        navigate(
          {
            hash: 'US',
          },
          { replace: true }
        );
        setValue('US');
        break;
    }
  };

  const handleChange = (_, newValue) => {
    handleTabSelect(newValue);
  };

  useEffect(() => {
    if (location.hash === '') {
      navigate(
        {
          hash: 'US',
        },
        { replace: true }
      );
    } else {
      handleTabSelect(location.hash?.replace('#', ''));
    }
  }, [location.hash]);

  return (
    
    <MDBox pt={1} pb={3}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            <MDBox>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab
                  label="US Users"
                  value={'US'}
                  id="us"
                  {...a11yProps(0)}
                />
                <Tab
                  label="Non-US Users"
                  value={'NonUS'}
                  id="non-us"
                  {...a11yProps(1)}
                />
                <Tab label="Duplicate Users" value={'Duplicate'} id='duplicate-users' />
              </Tabs>
              {/* <Outlet /> */}
            </MDBox>

            <TabPanel value={value} index={'US'}>
              <USUsers />
            </TabPanel>
            <TabPanel value={value} index={'NonUS'}>
              <NonUSUsers />
            </TabPanel>
            <TabPanel value={value} index={'Duplicate'}>
              <DuplicateUsers />
            </TabPanel>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
    
  );
};

export default UserManagement;
